<div
  class="tt-loading-state"
  [class.tt-loading-state--compact]="compact && !inline"
  [class.tt-loading-state--inline]="inline"
  role="status"
  aria-live="polite"
  [attr.aria-busy]="true"
>
  <app-spinner [size]="spinnerSize"></app-spinner>
  <p *ngIf="showMessage && message" class="tt-loading-state__message">{{ message }}</p>
</div>
